(function () {
  function searchDropdownTop() {
    var topbar = document.getElementById('topbar');
    var section = document.querySelector('.section-header');
    var headerInner = document.getElementById('header-sticky');
    var logo = document.querySelector('.header__logo');
    var searchInput = document.querySelector('.header_search .search__input');

    var bottoms = [];

    if (topbar) {
      bottoms.push(topbar.getBoundingClientRect().bottom);
    }
    if (section) {
      bottoms.push(section.getBoundingClientRect().bottom);
    }
    if (headerInner) {
      bottoms.push(headerInner.getBoundingClientRect().bottom);
    }
    if (logo) {
      bottoms.push(logo.getBoundingClientRect().bottom);
    }
    if (searchInput) {
      bottoms.push(searchInput.getBoundingClientRect().bottom);
    }

    if (!bottoms.length) return null;
    return Math.ceil(Math.max.apply(null, bottoms));
  }

  function applySearchDropdownTop() {
    var top = searchDropdownTop();
    if (top == null) return;

    document.documentElement.style.setProperty('--teavity-search-dropdown-top', top + 'px');

    var popup = document.querySelector('.header .popup-search.popup-search-form');
    if (popup) {
      popup.style.top = top + 'px';
    }
  }

  function init() {
    applySearchDropdownTop();
    window.addEventListener('resize', applySearchDropdownTop);
    window.addEventListener('scroll', applySearchDropdownTop, { passive: true });

    document.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.header_search') || e.target.closest('.search__input')) {
          requestAnimationFrame(applySearchDropdownTop);
          setTimeout(applySearchDropdownTop, 50);
        }
      },
      true
    );

    document.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches('.header_search input[type="search"]')) {
        applySearchDropdownTop();
        setTimeout(applySearchDropdownTop, 50);
      }
    });

    var headerSearch = document.querySelector('header-search');
    if (headerSearch && window.MutationObserver) {
      new MutationObserver(function () {
        if (headerSearch.querySelector('.popup-search.popup-search-show')) {
          applySearchDropdownTop();
          setTimeout(applySearchDropdownTop, 50);
        }
      }).observe(headerSearch, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
